import { render, staticRenderFns } from "./KTabsItems.vue?vue&type=template&id=20d1b310"
import script from "./KTabsItems.vue?vue&type=script&lang=js"
export * from "./KTabsItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTabsItems})
